import { lazy } from "react"
import { ANIMAL_EVENT_LIST_VIEW, NEW_ANIMAL_EVENT_VIEW } from "./route-list"
import DesktopSidebarLayout from "@/layouts/desktop-sidebar-layout/desktop-sidebar-layout.tsx"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout.tsx"

const AnimalEventView = lazy(
  () =>
    import(
      "@/features/events/animal-events/views/animal-event-view/animal-event-view.tsx"
    ),
)
const AnimalEventsPage = lazy(
  () =>
    import(
      "@/features/events/animal-events/views/animal-events-page/animal-events-page.tsx"
    ),
)
const NewAnimalEventView = lazy(
  () =>
    import(
      "@/features/events/animal-events/views/new-animal-event-view/new-animal-event-view.tsx"
    ),
)

export const noMenuLayoutAnimalEventRoutes = [
  {
    path: ANIMAL_EVENT_LIST_VIEW,
    element: <AnimalEventsPage />,
  },
  {
    path: `${NEW_ANIMAL_EVENT_VIEW}`,
    element: <NewAnimalEventView />,
  },
  {
    path: `${ANIMAL_EVENT_LIST_VIEW}/:animalEventId`,
    element: <AnimalEventView />,
  },
  {
    path: `${NEW_ANIMAL_EVENT_VIEW}/:animalId?/:typeId?`,
    element: <NewAnimalEventView />,
  },
]

export const MOBILE_ANIMAL_EVENT_ROUTES = [
  {
    element: <NoMenuLayout />,
    children: noMenuLayoutAnimalEventRoutes,
  },
]

const DESKTOP_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: noMenuLayoutAnimalEventRoutes,
  },
]

export const getAnimalEventRoutes = (isDesktop: boolean) => {
  if (isDesktop) {
    return DESKTOP_ROUTES
  }
  return MOBILE_ANIMAL_EVENT_ROUTES
}
